import { UPDATE_SERVER_STATUS } from './constants'

// Initial state of the store
const initialState = {
    // tq: { status: 'online', numPlayers: 1000 }
}

function updateServer(status, count) {
    let numPlayers = 0

    if (status === 'online' || status === 'vip') {
        numPlayers = count
    }

    return {
        status,
        numPlayers,
    }
}

// Commands for the state machine
const sync = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SERVER_STATUS: {
            const { serverId, status, count } = action.payload
            return {
                ...state,
                [serverId]: updateServer(status, count),
            }
        }

        // Default state
        default:
            return state
    }
}

export default sync



// WEBPACK FOOTER //
// ./src/features/Sync/data/serverStatuses/reducer.js